module.exports = __webpack_public_path__ + "img/element_5.08df6e9b.png";